import * as Yup from 'yup';
import { PqrResponseMedium } from '../../../../../../shared/types/modules/pqr';

export const initialValues: PqrResponseMedium = {
    responseMedium: '',
};

export const validationSchema = Yup.object({});
